var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9931 10.7304H18.4504L13.7305 3.62707C13.5903 3.39342 13.3099 3.30005 13.0763 3.30005C12.796 3.34674 12.609 3.48701 12.5154 3.76735L7.56182 17.1324L4.29049 11.1042C4.15022 10.8706 3.91657 10.7303 3.68293 10.7303H-2.29903C-2.67296 10.7303 -3 11.0573 -3 11.4313C-3 11.8052 -2.67298 12.1322 -2.29903 12.1322H3.26214L7.04745 19.1888C7.18773 19.4224 7.42138 19.5627 7.65501 19.5627H7.7017C7.98203 19.5627 8.21568 19.3757 8.30926 19.0954L13.2628 5.54302L17.422 11.8053C17.5623 11.9923 17.7491 12.1324 17.983 12.1324H24.899C25.273 12.1324 25.6 11.8053 25.6 11.4314C25.6002 11.0577 25.3666 10.7306 24.9927 10.7306L24.9931 10.7304Z",
    fill: "#FF8C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveReport);
export default __webpack_public_path__ + "static/media/active-report.929e7a40ef87a304c51cbba11868b2d6.svg";
export { ForwardRef as ReactComponent };